import Dashboard from 'pages/dashboard/Dashboard';
import Health from 'pages/health/Health';
import MeetKeyRedirect from 'pages/meetKeyRedirect/MeetKeyRedirect';
import UpgradeDashboard from 'pages/upgradeDashboard/UpgradeDashboard';
import UpgradeDashboardVonage from 'pages/upgradeDashboardVonage/UpgradeDashboardVonage';
import { BrowserRouter as Router, Route, Routes, useParams } from 'react-router-dom';

const MEET_KEY_PATTERN = /^[A-Za-z0-9]{6}$/;

function RouteByMeetParam() {
  const { meetId } = useParams();
  if (MEET_KEY_PATTERN.test(meetId ?? '')) {
    return <MeetKeyRedirect />;
  }
  return <Dashboard />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path=":meetId" element={<RouteByMeetParam />} />
        <Route path="health" element={<Health />} />
        <Route path="video" element={<UpgradeDashboard />} />
        <Route path="vid" element={<UpgradeDashboardVonage />} />
      </Routes>
    </Router>
  );
}


export default App;
